<template>
  <div class="container align-items-center flex-column d-flex justify-content-center">
    <div class="header-bg">
      <!-- Web -->
      <div class="display-web align-items-center mt-5 mb-2">
        <div class="left-header-web text-left">
          <span class="click-pointer" @click="redirectTo('/home')">
            <img class="ambpoker-logo"
              src="../assets/logo/ambpoker_logo.png" alt="amb logo" />
          </span>
        </div>
        <div v-if="isLogin" class="d-flex justify-content-end">
          <div class="d-flex align-items-center">
            <div @click="clearPasswordDialog()" class="p-2 header-btn ml-2 click-pointer">
              <font-awesome-icon class="header-icon icon-size mr-2" :icon="['fa', 'key']" />
              <span class="text-size">เปลี่ยนรหัสผ่าน</span>
            </div>
            <div @click="userLogout()" class="p-2 header-btn ml-2 click-pointer">
              <font-awesome-icon
                class="header-icon icon-size mr-2"
                :icon="['fa', 'sign-out-alt']"
              />
              <span class="text-size">ออกจากระบบ</span>
            </div>
            <div @click="playnow()" class="p-2 header-btn ml-2 click-pointer">
              <!-- <font-awesome-icon
              class="header-icon icon-size mr-2" :icon="['fas', 'gamepad']" /> -->
              <i class="fas fa-gamepad header-icon icon-size mr-2"></i>
              <span class="text-size">เล่นทันที</span>
            </div>
          </div>
          <div class="border-userInfo d-flex align-items-center pl-2 ml-2 font-weight-bold">
            <font-awesome-icon class="color-green icon-size" :icon="['fa', 'user']" />
            <div class="d-inline-flex flex-column align-items-start mx-2">
              <span class="color-yellow text-size">{{$session.get("nickname")}}</span>
              <span class="color-green userInfo-size">{{$session.get("username")}}</span>
            </div>
            <font-awesome-icon class="color-green icon-size" :icon="['fa', 'dollar-sign']" />
            <span class="color-yellow text-size mx-2">{{formatterCurrency(walletD)}}</span>
            <span class="color-green text-size mx-2">{{$session.get("currency")}}</span>
            <i
              class="fas fa-sync-alt color-green pr-2 click-pointer refresh"
              @click="refreshWallet()" >
            </i>
          </div>
        </div>
        <div v-else class="d-flex justify-content-end">
          <div class="d-inline-flex align-items-center border-userInfo w-25">
            <font-awesome-icon class="color-green ml-2 icon-size" :icon="['fa', 'user']"/>
            <div class="w-100">
              <input
                type="text"
                v-model="username"
                class="web-text-container uppercase"
                placeholder="ชื่อผู้ใช้"
                autocomplete="off"
              />
            </div>
          </div>
          <div class="d-inline-flex align-items-center border-userInfo w-25 ml-2">
            <font-awesome-icon class="color-green ml-2 icon-size" :icon="['fa', 'lock']" />
            <input
              type="password"
              v-model="password"
              v-on:keyup.enter="login()"
              class="web-text-container uppercase"
              placeholder="รหัสผ่าน"
            />
          </div>
          <div class="ml-2">
            <input type="button" class="web-login-btn" @click="login()" value="ลงชื่อเข้าใช้" />
          </div>
        </div>
      </div>
      <!-- Mobile -->
      <div class="display-mobile justify-content-between align-items-center color-white">
        <span class="side-navbar-expand text-left flex-basis-20" @click="openNav()">&#9776;</span>
        <div class="w-50">
          <span class="click-pointer" @click="redirectTo('/home')">
            <img class="ambpoker-logo"
              src="../assets/logo/ambpoker_logo.png" alt="amb logo" />
          </span>
        </div>
        <div class="flex-basis-20 font-weight-bold">
          <input
            v-if="isLogin"
            type="button"
            class="mobile-button w-100 py-2"
            @click="userLogout()"
            value="ออกจากระบบ"
          />
          <input
            v-if="!isLogin"
            type="button"
            class="mobile-button w-100 py-2"
            @click="showLoginDialog()"
            value="ลงชื่อเข้าใช้"
          />
        </div>
      </div>
       <div class="display-mobile font-weight-bold mb-2">
          <input
            v-if="isLogin"
            type="button"
            class="mobile-button w-100 py-2"
            @click="playnow()"
            value="เล่นทันที"
          />
        </div>
    </div>
    <!-- User Info Mobile -->
    <div v-if="isLogin" class="d-flex justify-content-around display-mobile border-userInfo w-100">
      <div class="d-inline-flex align-items-center">
        <font-awesome-icon class="icon-size color-green" :icon="['fa', 'user']" />
        <div class="d-flex flex-column align-items-start ml-2 font-weight-bold">
          <span class="color-yellow text-size">{{$session.get("nickname")}}</span>
          <span class="color-green userInfo-size">{{$session.get("username")}}</span>
        </div>
      </div>
      <div class="d-inline-flex align-items-center">
        <font-awesome-icon class="icon-size color-green" :icon="['fa', 'dollar-sign']"/>
        <span class="color-yellow text-size font-weight-bold ml-2">
          {{ formatterCurrency(walletD) }}
        </span>
        <i class="fas fa-sync-alt color-green ml-1 click-pointer refresh"
          @click="refreshWallet()" >
        </i>
      </div>
    </div>
    <!-- Sidebar -->
    <div id="mySidenav" class="sidenav z-index-strong">
      <a href="javascript:void(0)" class="closebtn" @click="closeNav()">&times;</a>
      <router-link :to="{ path: '/home' }">
        <img class="ambpoker-logo"
          src="../assets/logo/ambpoker_logo.png" alt="amb logo" />
      </router-link>
      <section v-for="(menu, i) in sidebarMenu" :key="i" class=''>
        <hr>
        <div
          v-if="!menu.dropdown"
          @click="redirectTo(menu.path)"
          class="d-flex align-items-center justify-content-start ml-2 color-white">
            <span class="w-25">
              <img
                :src="menu.img"
                width="100%"
                class="img-responsive"
                :alt="menu.alt"
              />
            </span>
            <span>{{menu.text}}</span>
        </div>

        <div v-if="menu.showCollapse">
           <span v-b-toggle.collapse-a
                class="d-flex align-items-center justify-content-start ml-2 color-white"
            >
              <img
              :src="menu.img"
              width="25%"
              class="img-responsive"
              :alt="menu.alt"
              /><span>{{menu.text}}&nbsp;<i class="fa fa-sort-down"></i></span>
          </span>
          <b-collapse v-for="(item, i) in dropdownRule" :key="i"  id="collapse-a" class="mt-1">
            <b-card class="rule-content" @click="redirectTo(item.path)">{{item.name}}</b-card>
          </b-collapse>
        </div>
      </section>
      <section v-if="isLogin" @click="changePasswordDialog = true">
        <hr>
        <div class="d-flex align-items-center justify-content-start ml-2 color-white">
          <span class="w-25">
            <img
              src="../assets/icon/Key-min.png"
              width="100%"
              class="img-responsive"
              alt="Keymin-img"
            />
          </span>
          <span>เปลี่ยนรหัสผ่าน</span>
        </div>
      </section>
      <hr>
    </div>
    <!-- Login Dialog -->
    <b-modal
      header-class="dialog-header"
      body-class="dialog-body"
      v-model="loginDialog" hide-footer
      title="เข้าสู่ระบบ"
    >
      <section>
        <div class="d-flex align-items-center justify-content-end mb-3">
          <font-awesome-icon :icon="['fa', 'user']" class="icon-size" />
          <span class="no-break-line mx-1">ชื่อผู้ใช้&nbsp;:</span>
          <input
              class="dialog-text-container uppercase"
              type="text"
              v-model="username"
              placeholder="ชื่อผู้ใช้"
            />
        </div>
        <div class="d-flex align-items-center justify-content-end mb-3">
          <font-awesome-icon :icon="['fa', 'lock']" class="icon-size" />
          <span class="no-break-line mx-1">รหัสผ่าน&nbsp;:</span>
          <input
            class="dialog-text-container"
            type="password"
            v-model="password"
            placeholder="รหัสผ่าน"
          />
        </div>
        <div class="d-flex align-items-center justify-content-end mb-1">
            <button
              @click="login()"
              type="button"
              class="btn btn-success btn-sm">ลงชื่อเข้าใช้
            </button>
        </div>
      </section>
    </b-modal>
    <!-- Change password Dialog -->
    <b-modal
      header-class="dialog-header"
      body-class="dialog-body"
      v-model="changePasswordDialog" hide-footer
      title="เปลี่ยนรหัสผ่าน"
    >
      <section>
        <div class="d-flex align-items-center justify-content-end mb-3">
          <span class="no-break-line mx-1">รหัสผ่านปัจจุบัน&nbsp;:</span>
          <input
              class="dialog-text-container"
              type="password"
              v-model="changePassword.currentPassword"
              placeholder="รหัสผ่านปัจจุบัน"
            />
        </div>
        <div class="d-flex align-items-center justify-content-end mb-3">
          <span class="no-break-line mx-1">รหัสผ่านใหม่&nbsp;:</span>
          <input
              class="dialog-text-container"
              type="password"
              v-model="changePassword.newPassword"
              placeholder="รหัสผ่านใหม่"
            />
        </div>
        <div class="d-flex align-items-center justify-content-end mb-3">
          <span class="no-break-line mx-1">ยืนยันรหัสผ่านใหม่&nbsp;:</span>
          <input
              class="dialog-text-container"
              type="password"
              v-model="changePassword.confirmPassword"
              placeholder="ยืนยันรหัสผ่านใหม่"
            />
        </div>
        <div class="d-flex align-items-center justify-content-end mb-1">
          <button
            @click="onClickChangePassword()"
            type="button" class="btn btn-success">บันทึก
          </button>
        </div>
      </section>
    </b-modal>
    <!-- error authen modal -->
    <b-modal
      header-class="dialog-header"
      body-class="dialog-body"
      v-model="errorAuthen"
      hide-footer
      title="Error"
      max-width="510px"
    >
      <section>
        <div class="d-flex justify-content-center align-items-center mb-3">
          <strong>{{ errText }}</strong>
        </div>
        <div class="d-flex justify-content-end align-items-center">
          <button
            @click="errorAuthen = false"
            type="button" class="btn btn-success btn-sm">ตกลง
          </button>
        </div>
      </section>
    </b-modal>
    <b-alert
      v-if="checkAndroid"
      v-model="showBottom"
      class="position-fixed fixed-bottom m-0 rounded-0 downloadTap display-mobile"
      style="z-index: 2000;"
      variant="#213a29"
    >
      <section class="d-flex mt-2 pd-0">
        <div class="mt-2">
          <a class="iconClose" @click="showBottom = false">&times;</a>
        </div>
        <div class="col-3">
          <img class="icon" src="../assets/icon/iconapp.png" alt="icon-app">
        </div>
         <div class="col-4 text-left downloadText">
           <div>
            <span> AMBPOKER แอพมือถือ </span>
           </div>
           <div>
            <span> ดาวน์โหลดเดี๋ยวนี้ </span>
           </div>
        </div>
         <div class="col-4 text-right">
          <img
            class="iconLoading"
            src="../assets/icon/icon_loading.png"
            alt="icon-loading"
            @click="downloadAndroid()"
          >
        </div>
      </section>
    </b-alert>
  </div>
</template>

<script>
/* eslint-disable */
import { AUTH_REQUEST } from "../store/actions/auth";
import { AUTH_LOGOUT } from "../store/actions/auth";
import { CHANGE_USER_PASSWORD_REQUEST,
  GET_USER_BALANCE_REQUEST,
  GET_GAME_VERSION_REQUEST,
  GET_STATUS_REQUEST,
  USER_LOGOUT_REQUEST} from "../store/actions/profile";
import utils from "../services/utils";
import Vue from "vue";
import VueJwtDecode from "vue-jwt-decode";
import Download  from '../assets/icon/download.png'
import Gamerule  from '../assets/icon/gamerule.png'
import Faq  from '../assets/icon/faq.png'
import Security  from '../assets/icon/security.png'
import Termofuse  from '../assets/icon/termofuse.png'
import Contactus  from '../assets/icon/contactus.png'
import socketConnect from '../vue-socket'
import {ENV} from '../utils/api/index'
import {EventBus} from '../services/event-bus'

export default {
  name: "login",
  created() {
    window.addEventListener('resize', this.redirectToHome)
    this.validateReceivedToken();
    this.handleParams();
    this.refreshWallet();
    this.isAndroid();
  },
  data() {
    return {
      checkAndroid: false,
      showBottom: true,
      device: this.$browserDetect,
      showCollapse: false,
      userData: utils.getUserPersistent(),
      errorAuthen: false,
      errText: '',
      username: '',
      password: '',
      isLogin: this.$session.exists(),
      changePassword: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
      changePasswordDialog: false,
      loginDialog: false,
      bodyBgVariant: 'light',
      bodyTextVariant: 'black',
      headerBgVariant: 'success',
      headerTextVariant: 'light',
      socketAuth: false,
      walletD: 0,
      urlParams: new URLSearchParams(window.location.search),
      sourceUser: '',
      usernameLogout: '',
      sidebarMenu: [
        // {
        //   img: Download,
        //   text: 'ดาวน์โหลด',
        //   alt: 'Download-img',
        //   dropdown: false,
        //   isLogin: false,
        //   path: '/download'
        // },
        {
          img: Gamerule,
          text: 'กติกาการเล่นเกมส์',
          alt: 'Gamerule-img',
          dropdown: true,
          showCollapse: true,
          isLogin: false,
        },
        {
          img: Faq,
          text: 'คำถามที่พบบ่อย',
          alt: 'Faq-img',
          dropdown: false,
          isLogin: false,
          path: '/faq'
        },
        {
          img: Security,
          text: 'ความปลอดภัย',
          alt: 'Security-img',
          dropdown: false,
          isLogin: false,
          path: '/security'
        },
        {
          img: Termofuse,
          text: 'การใช้งาน',
          alt: 'Termofuse-img',
          dropdown: false,
          isLogin: false,
          path: '/termofuse'
        },
        {
          img: Contactus,
          text: 'ติดต่อเรา',
          alt: 'Contactus-img',
          dropdown: false,
          isLogin: false,
          path: '/contactus'
        },
      ],
      dropdownRule: [
        {
          id: "r01",
          path: '/rule/ntpp',
          name: 'น้ำเต้าปูปลา',
          expand: false
        },
        {
          id: "r02",
          path: '/rule/tk_2cards',
          name: 'ตีไก่ 2 ใบ',
          expand: false
        },
        {
          id: "r03",
          path: '/rule/tk_3cards',
          name: 'ตีไก่ 3 ใบ',
          expand: false
        },
        {
          id: "r04",
          path: '/rule/13cardspoker',
          name: 'ไพ่สามกอง',
          expand: false
        },
        {
          id: "r05",
          path: '/rule/pokdeng',
          name: 'ป๊อกเด้ง',
          expand: false
        },
        {
          id: "r06",
          path: '/rule/11hilo',
          name: 'ไฮโล',
          expand: false
        },
        {
          id: "r07",
          path: '/rule/brp',
          name: 'เป่ายิงฉุบไม่มีเจ้า',
          expand: false
        },
        {
          id: "r08",
          path: '/rule/brb',
          name: 'เป่ายิงฉุบมีเจ้า',
          expand: false
        },
        {
          id: "r09",
          path: '/rule/punpae',
          name: 'ปั่นแปะ',
          expand: false
        },
        {
          id: "r10",
          path: '/rule/paikang',
          name: 'ไพ่แคง',
          expand: false
        },
        {
          id: "r11",
          path: '/rule/6cardspoker',
          name: 'ไพ่ 6 ใบ',
          expand: false
        },
        {
          id: "r12",
          path: '/rule/bingo',
          name: 'บิงโก',
          expand: false
        },
        {
          id: "r13",
          path: '/rule/bingo2',
          name: 'บิงโก 2',
          expand: false
        },
        {
          id: "r14",
          path: '/rule/football',
          name: 'นักเตะลูกหนังในตำนาน',
          expand: false
        },
        {
          id: "r15",
          path: '/rule/fruitslot',
          name: 'ฟรุตลูเรตสลอต',
          expand: false,
        },
        {
          id: "r16",
          path: '/rule/fishing',
          name: 'ทุ่งรักนักตกปลา',
          expand: false,
        },
        {
          id: "r17",
          path: '/rule/horseracing',
          name: 'เกมส์แข่งม้า',
          expand: false,
        },
        {
          id: "r18",
          path: '/rule/dragontiger',
          name: 'เสือมังกร',
          expand: false,
        },
        {
          id: "r19",
          path: '/rule/baccarat',
          name: 'บาคาร่า',
          expand: false,
        },
        {
          id: "r20",
          path: '/rule/pokdeng2',
          name: 'ป๊อกเด้ง2',
          expand: false,
        },
      ]
    };
  },
  sockets: {
    connect() {
      if (!this.socketAuth && this.$session.get("isLogin") === true) {
        this.emitToken();
      }
    },
    Authenticated(res) {
      this.$session.set("wallet", res.user.wallet.balance);
      this.$session.set("nickname", res.user.profile.nickname);
      this.socketAuth = true;
      this.emitGetUserOnline();
    },
    disconnect() {
      this.socketAuth = false;
    },
    disconnectTrigger(res) {
      this.showErrorModal(res.status.message);
      this.userLogout();
    },
    updatePlayerBalance(res) {
      const wallet = res.data.wallet;
      this.$session.set("wallet", wallet.balance);
    }
  },
  mounted() {
    EventBus.$on('logOut', () => {
      this.userLogout()
    })
  },
  methods: {
    redirectTo(path) {
      this.$router.push(path)
      this.closeNav()
    },
    showErrorModal(text) {
      this.errorAuthen = true;
      this.errText = text;
    },
    emitToken() {
      if (!this.$socket.connected) {
        this.$socket.connect();
      } else {
        this.$socket.emit("authenticate", {
          // token: this.$session.get("token")
          token: this.userData.token
        });
      }
    },
    emitGetUserOnline() {
      this.$socket.emit("getUpdateUserOnline", {}, res => {console.log('res :', res);});
    },
    formatterCurrency(amount) {
      return utils.currencyFormatter(amount);
    },
    validateReceivedToken() {
      if (this.$route.query.t !== undefined) {
        const token = this.$route.query.t
        const decoded = VueJwtDecode.decode(token)
        const now = Date.now().valueOf() / 1000;
        let data = {
          token: token,
          user: {
            username: decoded.username,
            profile: {
              nickname: decoded.nickname,
            },
            wallet: {
              balance: this.$session.get("wallet") ? this.$session.get("wallet") : 0,
            },
          }
        }
        if (typeof decoded.exp !== "undefined" && decoded.exp < now) {
          this.userLogout();
        } else {
          this.setAuthSession(data);
        }
      }
    },
    login() {
      let params = {
        username: this.username.toUpperCase(),
        password: this.password
      }
      this.$store
        .dispatch(AUTH_REQUEST, params)
        .then(resp => {
          const data = resp.data.data;
          this.usernameLogout = data.user.username
          this.sourceUser = data.user.source
          this.setAuthSession(data);
          Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.token
          socketConnect(data.token)
          this.refreshWallet();
          this.playnow()
        })
        .catch(err => {
          this.$message.error("Invalid username or password");
        });
    },
    setAuthSession(value) {
      this.loginDialog = false;
      this.$session.set("isLogin", true);
      this.$session.set("token", value.token);
      this.$session.set("nickname", value.user.profile.nickname);
      this.$session.set("username", value.user.username);
      this.$session.set("currency", value.user.currency);
      this.$session.set("rateCurrency", value.user.rateCurrency);
      this.$session.set("wallet", value.user.wallet.balance);
      this.$session.start(3600000);
      this.isLogin = true;
      this.username = '';
      this.password = '';
      this.emitToken();
    },
    clearPasswordDialog() {
      this.changePasswordDialog = true;
      this.changePassword.currentPassword = '';
      this.changePassword.newPassword = '';
      this.changePassword.confirmPassword = '';
    },
    onClickChangePassword() {
      this.changePasswordDialog = false;
      if (this.changePassword.newPassword !== this.changePassword.confirmPassword) {
        this.$message.error("รหัสผ่านที่กรอกไม่ตรงกัน");
      } else if (!this.changePassword.currentPassword) {
        this.$message.error("กรอกรหัสผ่านปัจจุบัน");
      } else {
        this.confirmChangePassword()
      }
      // this.changePasswordDialog = false
    },
    confirmChangePassword() {
      let params = {
        username: utils.getUserPersistent().user.username,
        confirmPassword: this.changePassword.confirmPassword,
        newPassword: this.changePassword.newPassword,
        oldPassword: this.changePassword.currentPassword
      }
      this.$store
        .dispatch(CHANGE_USER_PASSWORD_REQUEST, params)
        .then(resp => {
          this.$message.success("สำเร็จ!! เปลี่ยนแปลงรหัสผ่านเรียบร้อยแล้ว");
          this.changePassword.currentPassword = '';
          this.changePassword.newPassword = '';
          this.changePassword.confirmPassword = '';
          this.changePasswordDialog = false;
          this.userLogout();
        })
        .catch(err => {
        if(err === 1002){
          this.userLogout()
          this.$message.error("กรุณา login ใหม่");
        }
        else
        this.$message.error("กรอกรหัสผ่านปัจจุบัน");
        });
    },
    openNav() {
      document.getElementById("mySidenav").style.width = "55%";
    },
    closeNav() {
      document.getElementById("mySidenav").style.width = "0%";
    },
    showLoginDialog() {
      this.loginDialog = true;
      this.username = '';
      this.password = '';
    },
     handleParams() {
      if (this.urlParams.get('logout')) {
        this.userLogout()
      }
    },
    playnow() {
       let params = {
        type: 'website',
        env: ENV,
        source: 'ambpoker'
      }
      this.$store
        .dispatch(GET_GAME_VERSION_REQUEST, params)
        .then(resp => {
          let data = resp
          if(resp.data.status.code === 0){
            if(utils.getUserPersistent().token === null) {
              this.$message.error("กรุณา login ใหม่");
              return this.userLogout()
            }
            this.getGames(data)
          }
          if(resp.data.status.code === 1002){
            this.userLogout()
            this.$message.error("บัญชีมีการ login จากเครื่องอื่น");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    refreshWallet(){
      if (utils.getUserPersistent().token) {
        this.$store
          .dispatch(GET_USER_BALANCE_REQUEST)
          .then(resp => {
            this.walletD = Number(resp.data.data.wallet.balance * resp.data.data.rateCurrency)
          })
          .catch(err => {
            this.userLogout()
            this.$message.error("กรุณา login ใหม่");
          })
      }
    },
    getGames(data) {
      this.$store
        .dispatch(GET_STATUS_REQUEST)
        .then(resp => {
          if(resp.data.status.code === 0 ){
          const urlGame = `${data.data.data.url}?t=${utils.getUserPersistent().token}&language=${data.data.data.language}`
          const Features = "top=0,left=0,height=768,width=1366,scrollbars=no"
          if (this.device.isIOS) return window.location.href = urlGame, "_blank"
          return window.open(urlGame, "Game", Features)
          }
          if(resp.data.status.code === 1002){
            this.$message.error("กรุณา login ใหม่");
            return this.userLogout()
          }
        })
        .catch(err => {
          console.log('getgame', err)
      })
    },
    userLogout(){
      let params = {
        username: utils.getUserPersistent().user.username,
        source: utils.getUserPersistent().user.source
      }
      this.$store
        .dispatch(USER_LOGOUT_REQUEST, params)
        .then(resp => {
          // this.$session.destroy();
          // localStorage.clear();
          this.isLogin = false;
          this.$socket.disconnect();
          socketConnect(this.$baseToken)
        })
        .catch(err => {
          if (err === 1002) this.isLogin = false;
        });
    },
    isAndroid() {
      if (/Android/i.test(navigator.userAgent)) {
       this.checkAndroid = true
      }
      if(this.checkAndroid) {
        const item = {
          img: Download,
          text: 'ดาวน์โหลด',
          alt: 'Download-img',
          dropdown: false,
          isLogin: false,
          path: '/download'
        }
        this.sidebarMenu.splice(0, 0, item)
      }
    },
    downloadAndroid(){
      window.location.href = `${this.$urlDownload}`;
    },
    redirectToHome() {
      if (window.innerWidth > 600) {
        this.loginDialog = false;
        this.closeNav()
      }
    }
  }
}
</script>

<style scoped>
.color-green {
  color:#48ff77;
}
.color-yellow {
  color: #f2ca4e;
}
.icon-size {
  font-size: 1.5rem;
}
.refresh {
  font-size: 1.1rem;
}
.text-size {
  font-size: 1rem;
}
.userInfo-size {
  font-size: 0.8rem;
}
.left-header-web {
  margin-right: auto;
  flex-basis: 25%;
}
.flex-basis-20 {
  flex-basis: 20%
}
@media only screen and (max-width: 1024px) {
  .icon-size {
    font-size: 1.3em;
  }
  .text-size {
    font-size: 0.8em;
  }
  .userInfo-size {
    font-size: 0.6rem;
  }
  .refresh{
    font-size: 0.8rem;
  }
}
@media only screen and (max-width: 576) {
  .icon-size {
    font-size: 1.5rem;
  }
  .refresh{
    font-size: 0.8rem;
  }
}
.z-index-strong {
  z-index: 999;
}
.header-container {
  width: 75%
}
.header-bg {
  font-family: "Prompt", sans-serif;
  width: 80%;
  height: auto;
}
.btn-changepassword-mobile {
  background: transparent;
  border: 0;
  color: #95a5a6;
  font-size: 2vw;
  font-weight: bold;
}
.modal-header {
  color: white !important;
  border-radius: 5px 5px 0px 0px !important;
  background-color: #0c5941 !important;
}
hr {
  margin-top: 0;
  margin-bottom: 0;
  border: 0;
  border-top: 2px solid #104d2f;
}
.dialog-text-container {
  border-radius: 5px;
  border: solid 1px #0c5941;
  background: linear-gradient(to bottom, #0b261b, #0c3918);
}
.expanded-game-rule {
  background-color: black;
  text-align: left;
  opacity: 0.9;
}
.border-userInfo {
  border: solid 1px #48ff77;
  background: linear-gradient(to bottom, #0c3918, #0b261b);
  border-radius: 5px;
}
.web-login-btn {
  padding: 5px 20px;
  font-size: 1vw;
  border-radius: 5px;
  border-color: transparent;
  background: linear-gradient(to bottom, #32a876, #43de84);
  cursor: pointer;
  font-weight: bold;
}
.web-login-btn:hover {
  background: linear-gradient(to bottom, #43de84, #32a876);
  color: white;
}
.web-text-container {
  background-color: transparent;
  border: none;
  color: white;
  margin-left: 0.5rem;
  font-size: 1vw;
  box-sizing: border-box;
  width: 93%;
}
.mobile-button {
  font-size: 3vw;
  border-radius: 5px;
  border-color: transparent;
  background: linear-gradient(to bottom, #32a876, #43de84);
  cursor: pointer;
  font-weight: bold;
  color: black;
}
.mobile-button:hover {
  background: linear-gradient(to bottom, #43de84, #32a876);
  color: white;
}
.header-btn {
  border-radius: 5px;
  color: black;
  background: linear-gradient(to bottom, #32a876, #43de84);
}
.header-btn:hover {
  background: linear-gradient(to bottom, #43de84, #32a876);
  color: white;
}
.header-btn:hover .header-icon {
  color: white;
}
.header-icon {
  color: black;
}
.dropdown-menu {
  width: 100%;
  left: 15px !important;
}
.refresh:hover{
  color: white;
}
.rule-content {
  background-color: black;
  color: #ffffff;
  padding: 0.3rem;
  text-align: center;
}
.downloadTap {
  background-color: #213a29;
  color: #ffffff;
  padding: 1px;
}
.icon{
  width: 100%;
  margin-bottom: 0.5rem;
}
.downloadText {
  font-size: 3vw;
  padding: 0%;
  margin-top: 4%;
}
.iconClose{
  font-size: 30px;
  margin-left: 1rem;
  color: #ffffff;
}
.iconLoading{
  width: 50%;
  margin-top: 10%;
}
.ambpoker-logo {
  width: 50%;
}
</style>
